import wealth from "constants/wealth";
import { Col, Container, Row } from "react-bootstrap";
import { Jumbotron } from "sections";
import parse from "html-react-parser";
import "../personal.css";
import outline_check from "assets/images/outline_check.svg";
import EnquiryForm from "components/forms/EnquiryForm";

import Wealth from "assets/images/hero-images/wealth.png";
import BG from "assets/images/hero-images/BG.png";

function StructuredProduct() {
  return (
    <div>
      <section className="section jumbotron">
        <Jumbotron
          badgeText="Wealth Management"
          title={`<span className="jumbotron-subtitle-2">Structured</span> Product-<em>i</em>`}
          buttonText="Let's connect!"
          backgroundImage={Wealth}
          uniqueBg={BG}
        />
      </section>
      <section className="wealth">
        <Container>
          <Row>
            <Col md={4}>
              <h2>{wealth.structuredProduct.about.title}</h2>
            </Col>
            <Col md={8}>
              {parse(wealth.structuredProduct.about.description)}
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>{wealth.structuredProduct.benefits.title}</h2>
            </Col>
            <Col md={8}>
              <div className="mb-3">
                {wealth.structuredProduct.benefits.subtitle}
              </div>
              <div className="features-container flex-wrap">
                {wealth.structuredProduct.benefits.description.map(
                  (benefit, index) => (
                    <div
                      className="benefits-card"
                      style={{ flexBasis: "30%" }}
                      data-aos="fade-right"
                      data-aos-delay={`${index + 1}00`}
                    >
                      {parse(benefit)}
                    </div>
                  )
                )}
              </div>
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>{wealth.structuredProduct.eligibilty.title}</h2>
            </Col>
            <Col md={8}>
              <div>
                {wealth.structuredProduct.eligibilty.description.map(
                  (eligibilty, index) => (
                    <div
                      className="eligibility-list"
                      data-aos="zoom-in-down"
                      data-aos-delay={`${index + 1}00`}
                    >
                      <img src={outline_check} width="16" alt="outline_check" />
                      {parse(eligibilty)}
                    </div>
                  )
                )}
              </div>
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>{parse(wealth.structuredProduct.getStarted.title)}</h2>
            </Col>
            <Col md={8}>
              {wealth.structuredProduct.getStarted.description.map(
                (getStarted, index) => (
                  <div data-aos="fade-right" data-aos-delay={`${index + 1}00`}>
                    {parse(getStarted)}
                  </div>
                )
              )}
            </Col>
          </Row>
          <Row className="my-5 py-5">
            <Col md={4}>
              <h2>Let's connect!</h2>
              <span className="text-black-50">
                Share your information, and we'll get back to you with the
                answers you need.
              </span>
            </Col>
            <Col md={8}>
              <EnquiryForm />
            </Col>
          </Row>
        </Container>
      </section>
    </div>
  );
}

export default StructuredProduct;
